export function initWorldConnector(store) {
  window.IS24 = window.IS24 || {};
  window.IS24.PropertyBook = window.IS24.PropertyBook || {};
  window.IS24.PropertyBook.data = window.IS24.PropertyBook.data || {};
  window.IS24.PropertyBook.error = window.IS24.PropertyBook.error || {};

  window.IS24.PropertyBook.onPageletReceiveSuccessful = (pageletName, data) => {
    store.dispatch({ type: `UPDATE_${pageletName}`, value: data });
  };
  window.IS24.PropertyBook.onPageletReceiveError = (pageletName) => {
    store.dispatch({ type: `ERROR_${pageletName}` });
  };
}

export function propertyBookLoaded() {
  Object.keys(window.IS24.PropertyBook.data).forEach((e) => {
    const data = window.IS24.PropertyBook.data[e];
    window.IS24.PropertyBook.onPageletReceiveSuccessful(e, data);
  });

  Object.keys(window.IS24.PropertyBook.error).forEach((e) => {
    const msg = window.IS24.PropertyBook.error[e];
    window.IS24.PropertyBook.onPageletReceiveError(e, msg);
  });
}
